import Vue from 'vue';

export default {
  name: 'Portal',
  data() {
    return {
      el: null,
      instance: null,
    };
  },
  created() {},
  mounted() {
    this.instance.$mount();
    this.el = this.instance.$el;
    document.body.appendChild(this.el);
  },
  beforeUpdate() {
    this.instance.$forceUpdate();
  },
  beforeDestroy() {
    this.instance.$destroy();
    if (this.el && this.el.parentElement !== null) {
      this.el.parentElement.removeChild(this.el);
    }
  },

  render() {
    this.renderToPortal();
    return null;
  },
  methods: {
    renderToPortal() {
      if (this.instance !== null) {
        return;
      }

      this.instance = new Vue({
        render: h => {
          const slots = this.$slots;
          const children = Object.keys(slots).reduce((arr, key) => arr.concat(slots[key]), []);

          if (children.length > 1) {
            return h('div', children);
          } else {
            return children[0];
          }
        },
      });
    },
  },
};
